module.exports = __webpack_public_path__ + "img/develope-digram.cc31f23f.png";